export const getElapsedTimeFromFormatted = (from: number): string => {
  const now = new Date().getTime();
  const elapsedMs = now - from + 1000;
  return new Date(elapsedMs).toISOString().substr(11, 8);
};
